import * as Cookies from 'js-cookie'

const state = {
    token: Cookies.get('access_token')
}

const mutations = {
    setToken (state, token) {
        state.token = token
        Cookies.set('access_token', token, { expires: 360 })
    },
    resetToken (state) {
        state.token = null
        Cookies.remove('access_token')
    }
}

const actions = {
    login ({ commit }, { username, password }) {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            window.axios.post(`/user/login`, {username: username, password: password})
                .then((res) => {
                    commit('setToken', res.data.access_token)
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                })
        })
    },
    logout ({ commit }) {
        return new Promise((resolve) => { // The Promise used for router redirect in login
            commit('resetToken')
            resolve()
        })
    }
}

const getters = {
    isAuthenticated: state => !!state.token
}

export default {
    state,
    mutations,
    actions,
    getters
}
